/**
 * Immersive-route flag (not persisted).
 *
 * Full-screen routes (the video editor) set it while mounted so app-level
 * floating controls rendered OUTSIDE the router — the learn-tips toggle — can
 * get out of the way on small screens. Live QA 2026-10-04: at 375 px the
 * help-tips FAB sat on top of the editor's "Review" tab and swallowed taps.
 */
import { createAppStore } from "@plerity/dashboard-shared/stores";

interface ImmersiveState {
  immersive: boolean;
  setImmersive: (value: boolean) => void;
}

export const useImmersiveStore = createAppStore<ImmersiveState>("social-immersive", (set) => ({
  immersive: false,
  setImmersive: (value) => set({ immersive: value }),
}));
